/** @format */

const data = [
  { id: 1, name: "Hawaii" },
  { id: 2, name: "Fiji" },
  { id: 3, name: "Curazao" },
  { id: 4, name: "Bali" },
  { id: 5, name: "Azores" },
  { id: 6, name: "Holbox" },
  { id: 7, name: "Tenerife" },
  { id: 8, name: "Mallorca" },
  { id: 9, name: "Malta" },
  { id: 10, name: "Palau" },
  { id: 11, name: "San Andres" },
  { id: 12, name: "Formentera" },
  { id: 13, name: "Galapagos" },
  { id: 14, name: "Zanzibar" },
  { id: 15, name: "Menorca" },
  { id: 16, name: "Hainan" },
  { id: 17, name: "Java" },
  { id: 18, name: "Gran Canaria" },
  { id: 19, name: "Bora Bora" },
  { id: 20, name: "Gran Cayman" },
  { id: 21, name: "Tahiti" },
  { id: 22, name: "Santorini" },
  { id: 23, name: "Creta" },
  { id: 24, name: "Borneo" },
  { id: 25, name: "Cyprus" },
  { id: 26, name: "Cozumel" },
  { id: 27, name: "Mujeres" },
  { id: 28, name: "Ibiza" },
  { id: 29, name: "Madagascar" },
  { id: 30, name: "Tasmania" },
  { id: 31, name: "Seychelles" },
  { id: 32, name: "Maldivas" },
  { id: 33, name: "Maurice" },
  { id: 34, name: "Aruba" },
  { id: 35, name: "Providence" },
  { id: 36, name: "Barbados" },
  { id: 37, name: "Cayman" },
  { id: 38, name: "Nassau" },
];
export default data;
